import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getMicrosoftAuthUrl } from "../api/auth";

const MICROSOFT_LOGO_SVG = (
  <svg width="18" height="18" viewBox="0 0 21 21" aria-hidden="true">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </svg>
);

interface Props {
  label?: string;
}

export default function MicrosoftSignInButton({ label }: Props) {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleClick() {
    setError(null);
    setLoading(true);
    try {
      const { url } = await getMicrosoftAuthUrl();
      window.location.href = url;
    } catch {
      setError(t("microsoftSignInFailed"));
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className={
          "inline-flex w-full items-center justify-center gap-3 rounded-md border border-slate-300 " +
          "bg-white px-4 py-2.5 text-sm font-medium text-slate-700 shadow-sm " +
          "transition-colors hover:bg-slate-50 active:bg-slate-100 " +
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-600 focus-visible:ring-offset-2 " +
          "disabled:cursor-not-allowed disabled:opacity-50"
        }
      >
        {MICROSOFT_LOGO_SVG}
        {loading ? t("redirecting") : (label ?? t("continueWithMicrosoft"))}
      </button>
      {error && (
        <p className="text-center text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
